import { Incident } from '@collector/sportsapi-types'

import { Tables } from '../tables'
import { getTable } from '../utils'

export type AssignIncidentOnPitchRecord = {
  eventId: number
  incidentId: Incident['id']
  participantTeamId: number
  xPos?: number
  yPos?: number
}

export async function setIncident(
  eventId: number,
  incidentId: Incident['id'],
  participantTeamId: number,
  xPos?: number,
  yPos?: number,
): Promise<void> {
  const table = getTable(Tables.ASSIGN_INCIDENT_ON_PITCH)

  await table.put(
    {
      eventId,
      incidentId,
      participantTeamId,
      xPos,
      yPos,
    },
    eventId,
  )
}

export async function remove(eventId: number): Promise<void> {
  const table = getTable(Tables.ASSIGN_INCIDENT_ON_PITCH)

  return table.delete(eventId)
}

export function get(
  eventId: number,
): Promise<AssignIncidentOnPitchRecord | undefined> {
  const table = getTable(Tables.ASSIGN_INCIDENT_ON_PITCH)

  return table.get(eventId)
}
